import UI from "../../components/ExcerciseTypes/Design/UserInterface";
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";

const json = {
  1: {
    // Exercise num
    unit: "Unit 7",
    id: "SB3-U7-P49-E1",
    audio: "img/FriendsPlus/Page48/Audio/audio-e3-p48.mp3",
    video: "Videos/e3.p48.mp4",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      // Row
      [{ url: "img/FriendsPlus/Page49/E1/1.jpg" }],
      [{ url: "img/FriendsPlus/Page48/E3/4.jpg" }],
      [
        // Column3
        { url: "img/FriendsPlus/Page48/E3/5.jpg" },
        { url: "img/FriendsPlus/Page48/E3/6.jpg", audioUrl: "img/FriendsPlus/Page48/Audio/hinh1-e3-p48.mp3", },
        { url: "img/FriendsPlus/Page48/E3/7.jpg" },
        { url: "img/FriendsPlus/Page48/E3/8.jpg", audioUrl: "img/FriendsPlus/Page48/Audio/hinh2-e3-p48.mp3", },
        { url: "img/FriendsPlus/Page48/E3/9.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page48/E3/10.jpg" }],
      [
        // Column5
        { url: "img/FriendsPlus/Page48/E3/11.jpg" },
        { url: "img/FriendsPlus/Page48/E3/12.jpg", audioUrl: "img/FriendsPlus/Page48/Audio/hinh3-e3-p48.mp3", },
        { url: "img/FriendsPlus/Page48/E3/13.jpg" },
        { url: "img/FriendsPlus/Page48/E3/14.jpg", audioUrl: "img/FriendsPlus/Page48/Audio/hinh4-e3-p48.mp3", },
        { url: "img/FriendsPlus/Page48/E3/15.jpg" },
      ],
      
      [{ url: "img/FriendsPlus/Page48/E3/16.jpg" }],
      [
        // Column3
        { url: "img/FriendsPlus/Page48/E3/17.jpg" },
        { url: "img/FriendsPlus/Page48/E3/18.jpg", audioUrl: "img/FriendsPlus/Page48/Audio/hinh5-e3-p48.mp3", },
        { url: "img/FriendsPlus/Page48/E3/19.jpg" },
        { url: "img/FriendsPlus/Page48/E3/20.jpg", audioUrl: "img/FriendsPlus/Page48/Audio/hinh6-e3-p48.mp3", },
        { url: "img/FriendsPlus/Page48/E3/21.jpg" },
      ],
    ],
  },
  2: {
    // Exercise num
    unit: "Unit 7",
    id: "SB3-U7-P49-E2",
    audio: "img/FriendsPlus/Page49/Audio/audio-e2-p49.mp3",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [
        // Column1
        { url: "img/FriendsPlus/Page49/E2/1.jpg" },
        {
          url: "img/FriendsPlus/Page49/E2/2.jpg",
          audioUrl: "img/FriendsPlus/Page49/Audio/tieude-e2-p49.mp3",
        },
        { url: "img/FriendsPlus/Page49/E2/3.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page49/E2/4.jpg" }],
      [
        // Column2
        { url: "img/FriendsPlus/Page49/E2/5.jpg" },
        {
          url: "img/FriendsPlus/Page49/E2/6.jpg",
          audioUrl: "img/FriendsPlus/Page49/Audio/hinh1-e2-p49.mp3",
        },
        { url: "img/FriendsPlus/Page49/E2/7.jpg" },
        {
          url: "img/FriendsPlus/Page49/E2/8.jpg",
          audioUrl: "img/FriendsPlus/Page49/Audio/hinh2-e2-p49.mp3",
        },
        { url: "img/FriendsPlus/Page49/E2/9.jpg" },
      ],
      [
        // Column2
        { url: "img/FriendsPlus/Page49/E2/10.jpg" },
        {
          url: "img/FriendsPlus/Page49/E2/11.jpg",
          audioUrl: "img/FriendsPlus/Page49/Audio/hinh1-e2-p49.mp3",
        },
        { url: "img/FriendsPlus/Page49/E2/12.jpg" },
        {
          url: "img/FriendsPlus/Page49/E2/13.jpg",
          audioUrl: "img/FriendsPlus/Page49/Audio/hinh2-e2-p49.mp3",
        },
        { url: "img/FriendsPlus/Page49/E2/14.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page49/E2/15.jpg" }],
    ],
  },
  3: {
    // Exercise num
    unit: "Unit 7",
    id: "SB3-U7-P49-E3",
    audio: "",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: "img/FriendsPlus/Page49/E3/1.jpg" }]],
  },
  4: {
    // Exercise num
    unit: "Unit 7",
    id: "SB3-U7-P49-E4",
    audio: "",
    video: "",
    component: T6,
    exerciseKey: "img/FriendsPlus/Page49/E4/Key/answerKey.png",
    inputSize: 200,
    checkUppercase: true,
    titleImage: "",
    titleQuestion: [{ color: "#44509f", num: "4", title: 'Look again and write.' }],
    questionImage: [],
    questions: [
      {
        title: `
          <div>
            <img src="img/FriendsPlus/Page49/E4/title.jpg" style="width: 100%">
            <div style='display: flex; flex-direction: row;position: relative;'>
              <div style='width: '50%'>
                <div>1&nbsp;&nbsp;Does she work in a store?</div>
                <div>2&nbsp;&nbsp;Does he work in a hospital?</div>
                <div>3&nbsp;&nbsp;Does he work in a fire station?</div>
                <div>4&nbsp;&nbsp;Does she work in a school?</div>
              </div>
              <div style='width: '50%'>
                <div>&ensp;<u style='text-decoration-color: black;color:rgb(82,197,235)'>&ensp;No, she doesn’t.&ensp;</u></div>
                <div>#.</div>
                <div>#.</div>
                <div>#.</div>
              </div>
            </div>
          </div>
        `,
        answer: ["No, he doesn't", "Yes, he does", "Yes, she does"],
      },
    ],
  },
  5: {
    // Exercise num
    unit: "Unit 7",
    id: "SB3-U7-P49-E5",
    audio: "",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: "img/FriendsPlus/Page49/E5/1.jpg" }]],
  },
};

export default json;
